import React from 'react'
import classNames from 'classnames'
import { compose, onlyUpdateForKeys } from 'recompose'
import { connect } from 'react-redux'

import { LIST_ITEM_INDENT_PADDING } from '../constants'
import { actions as PublicUIActions } from 'data/publicUI'
import { getNote } from 'data/publicNotes/selectors'
import { isNoteActive } from 'data/publicUI/selectors'
import NoteIcon from 'components/Notes/Icon'
import { ChevronIconNew } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'

import provideSectionState from './provideSectionState'
import { isNoteExpanded } from 'data/publicUI/selectors'

const enhance = compose(
  onlyUpdateForKeys(['item']),
  provideSectionState,
  connect(
    (state, { item }) => {
      const { noteId } = item.data
      const note = getNote(state, noteId)

      return {
        noteId,
        note,
        isActive: isNoteActive(state, noteId),
        isExpanded: isNoteExpanded(state, noteId),
      }
    },
    {
      setActiveNoteId: PublicUIActions.setActiveNoteId,
      toggleExpandNote: PublicUIActions.toggleExpandNote,
    }
  )
)

function NoteItemLayout({
  noteId,
  note,
  isFirstLoading = false,
  isActive,
  isExpanded,

  // Style
  className,
  style = {},
  offset = 0,

  // Callbacks
  toggleExpandNote,
  setActiveNoteId,
}) {
  const onClickNote = React.useCallback(
    function() {
      setActiveNoteId(noteId)
    },
    [setActiveNoteId, noteId]
  )

  const onClickChevron = React.useCallback(
    function(event) {
      event.preventDefault()
      event.stopPropagation()
      toggleExpandNote({ noteId })
    },
    [toggleExpandNote, noteId]
  )

  if (isFirstLoading) {
    return false
  }

  return (
    <div style={style}>
      <div
        data-note-id={noteId}
        onClick={onClickNote}
        style={{
          marginLeft: offset * LIST_ITEM_INDENT_PADDING + 12,
          height: 40,
        }}
        className={classNames(
          className,
          'transition',
          'flexbox flexbox-align-center',
          'position-relative',
          'radius-normal',
          'margin-horizontal-normal  margin-bottom-smaller',
          'padding-vertical-small padding-horizontal-normal',
          'font-size-large font-weight-medium',
          'shade-05 background-shade-50-on-hover pointer',
          {
            'background-shade-50': isActive,
          }
        )}
      >
        <div className="flexbox flexbox-grow ellipsis">
          <div
            className="flexbox flexbox-no-shrink flexbox-centered margin-right-small"
            style={{ width: 20, height: 20 }}
          >
            <NoteIcon
              iconShape={note.iconShape}
              iconColor={note.iconColor}
              hasChildren={note.hasChildren}
            />
          </div>
          <div className="ellipsis font-weight-medium">
            {note.title || 'Untitled'}
          </div>
        </div>

        {note.hasChildren && (
          <IconButton
            colorScheme="grayOnGray"
            boxSize="smaller"
            onClick={onClickChevron}
          >
            <ChevronIconNew
              size={16}
              className={classNames({ 'rotate-clockwise': isExpanded })}
            />
          </IconButton>
        )}
      </div>
    </div>
  )
}

export default enhance(React.memo(NoteItemLayout))
